// @vue/component
export default {
  name: 'ga-app',

  setup() {
    const { $gaApp } = useNuxtApp()

    const focus = computed(() => $gaApp.stores.app.main.focusSource)
    const hover = computed(() =>
      $gaApp.stores.app.main.withHover ? 'supported' : 'unsupported',
    )

    const resizing = computed(() => $gaApp.stores.app.window.windowResizing)

    const lang = computed(() => unref($gaApp.i18n.locale).code || 'ru')

    const dir = computed(() => unref($gaApp.i18n.locale).dir || 'ltr')

    const webview = () => $gaApp.isWebview

    const mods = computed(() => {
      return {
        'data-app': '',
        'data-focus': focus,
        'data-resizing': resizing,
        'data-hover': hover,
        'data-i18n-lang': lang,
        'data-dir': dir,
        'data-webview': webview,
      }
    })

    // Используем useLocaleHead вместо $nuxtI18nHead
    const localeHead = useLocaleHead({
      addSeoAttributes: true,
    })

    useHead({
      htmlAttrs: {
        dir,
        ...localeHead.value.htmlAttrs, // в атрибутах содержится lang
      },
      meta: localeHead.value.meta,
      link: localeHead.value.link,
      bodyAttrs: mods,
    })
  },
}
